import React from 'react';
import styled, { css } from 'styled-components';
import CoreInput from 'gatsby-theme-core/src/components/form-elements/input';
import CoreTextarea from 'gatsby-theme-core/src/components/form-elements/textarea';
import Wrapper from './wrapper';
import Label from './label';

const Input = ({
  className,
  name,
  label = null,
  placeholder = null,
  required = false,
  type = 'text',
  onChange,
  value,
  horizontal = false,
  standout = false,
}) => {
  const Component = type === 'textarea' ? CoreTextarea : CoreInput;
  return (
    <Wrapper $singleColumn={!label} $type={type} $horizontal={horizontal} $standout={standout}>
      {label && <Label required={required} $type={type}>{label}</Label>}
      <Component
        $noSpacer
        className={className}
        type={type}
        name={name}
        placeholder={placeholder}
        required={required}
        onChange={onChange}
        value={value}
      />
    </Wrapper>
  );
};

export default styled(Input)`
  ${({ standout }) => standout && css`
    padding: 1.5rem 2rem;
  `}
`;
